export default {
    "audio.title": "Audio Summaries",
    "audio.subtitle": "Learn by listening to our detailed summaries of each chapter.",
    "audio.status.finished": "Finished",
    "audio.status.listening_now": "Listening now",
    "audio.status.playing": "Playing",
    "audio.status.no_audios": "No audio files available at the moment.",
    "audio.premium.title": "Access all audio guides",
    "audio.premium.description": "Unlock the full library of audio summaries to review anywhere, even without a screen.",
    "audio.premium.cta": "Go Premium"
};
